// Configuración local para los banners
// Cambiar a true para mostrar el banner, false para ocultarlo
export const BANNER_CONFIG = {
  // Banner informativo general
  INFO_BANNER_ENABLED: false,

  // Configuración del mensaje del banner informativo
  BANNER_MESSAGE: "🚧 La plataforma estará fuera de servicio el Jueves 23 de Abril de 12:00 PM a 10:00 PM por actualizaciones.",
  
  // Configuración adicional del banner informativo
  BANNER_TYPE: "info", // "info", "warning", "success", "error"
  BANNER_POSITION: "bottom", // "top", "bottom"
  BANNER_DISMISSIBLE: true, // Si el usuario puede cerrar el banner
};
